import React from "react";
// @ts-ignore
import UserIcon from "src/core/gd-components/icons/user-icon";

export default function FieldUser_InlineValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className="ui5-field-dropdown-inline-editable" onClick={props.onClick}>
                <UserIcon className="m-r-8" userId={props.option.value} size="22"/>
                <div className="ui5-txt-default">{props.option.label}</div>
            </div>

            {props.children}
        </React.Fragment>
    )
}